module.exports = __webpack_public_path__ + "static/media/invitations.2b77bc8d.svg";